module.exports = __webpack_public_path__ + "img/LargeFixedA.facc9815.png";